import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Utils, Validations, useKyc } from '@dfx.swiss/react';
import { Form, StyledButton, StyledButtonWidth, StyledHorizontalStack, StyledInput, StyledVerticalStack, } from '@dfx.swiss/react-components';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSettingsContext } from '../../contexts/settings.context';
import { ErrorHint } from '../error-hint';
export function NameEdit({ onSuccess }) {
    const { translate, translateError } = useSettingsContext();
    const { setName } = useKyc();
    const [isUpdating, setIsUpdating] = useState(false);
    const [error, setError] = useState();
    const { control, handleSubmit, formState: { isValid, errors }, } = useForm({ mode: 'onTouched' });
    function onSubmit(data) {
        setIsUpdating(true);
        setError(undefined);
        setName(data)
            .then(onSuccess)
            .catch((error) => {
            var _a;
            setError((_a = error.message) !== null && _a !== void 0 ? _a : 'Unknown error');
            setIsUpdating(false);
        });
    }
    const rules = Utils.createRules({
        firstName: Validations.Required,
        lastName: Validations.Required,
    });
    return (_jsx(Form, Object.assign({ control: control, rules: rules, errors: errors, onSubmit: handleSubmit(onSubmit), translate: translateError }, { children: _jsxs(StyledVerticalStack, Object.assign({ gap: 6, full: true }, { children: [_jsxs(StyledHorizontalStack, Object.assign({ gap: 2 }, { children: [_jsx(StyledInput, { name: "firstName", autocomplete: "firstname", label: translate('screens/kyc', 'First name'), placeholder: translate('screens/kyc', 'John'), full: true, smallLabel: true }), _jsx(StyledInput, { name: "lastName", autocomplete: "lastname", label: translate('screens/kyc', 'Last name'), placeholder: translate('screens/kyc', 'Doe'), full: true, smallLabel: true })] })), error && (_jsx("div", { children: _jsx(ErrorHint, { message: error }) })), _jsx(StyledButton, { type: "submit", label: translate('general/actions', 'Next'), onClick: handleSubmit(onSubmit), width: StyledButtonWidth.FULL, disabled: !isValid, isLoading: isUpdating })] })) })));
}
